import { ConfigCore } from '@shared/models/config';

export const getConfig = () => {
  return (window as any)?.AS as ConfigCore;
};
